const TeamModal = () => {
  if ($(".block-team").length) {
    $(".team-tabs > li").on("click", function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      $(".team-tabs-content").children().hide();
      $(".team-tabs-content").children().eq($(this).index()).show();
    });

    const teamModal = document.getElementById("teamBioModal");
    teamModal.addEventListener("show.bs.modal", function (event) {
      // Button that triggered the modal
      const button = event.relatedTarget;
      const name = button.getAttribute("data-bs-name");
      const position = button.getAttribute("data-bs-position");
      const photo = button.getAttribute("data-bs-photo");

      const bio = $(button).find('.team-bio').html();
      // If necessary, you could initiate an AJAX request here
      // and then do the updating in a callback.
      
      // Update the modal's content.
      const modalTitle = teamModal.querySelector(".team-name");
      const modalPosition = teamModal.querySelector(".team-position");
      const modalPhoto = teamModal.querySelector(".team-photo");
      const modalBio = teamModal.querySelector(".team-bio");

      modalTitle.textContent = name;
      modalPosition.textContent = position;
      modalBio.innerHTML = bio;
      modalPhoto.style.backgroundImage = `url(${photo})`;
    });
  }
};
export default TeamModal;
